<script lang="ts">
	interface Props {
		title?: string
		href?: string | null
		description?: string
		noMargin?: boolean
		wordBreakAll?: boolean
		titleSlot?: import('svelte').Snippet
		descriptionSlot?: import('svelte').Snippet
		icon?: import('svelte').Snippet
		iconAfter?: import('svelte').Snippet
		children?: import('svelte').Snippet
	}

	let {
		title = '',
		href = null,
		description = '',
		noMargin = false,
		wordBreakAll = false,
		titleSlot,
		descriptionSlot,
		icon,
		iconAfter,
		children,
	}: Props = $props()
</script>

<div class="flex flex-wrap items-center gap-3">
	{@render icon?.()}

	<h2
		class="font-display text-primary-900 text-lg font-bold lg:text-xl dark:text-white"
		class:break-all={wordBreakAll}
	>
		{#if titleSlot}
			{@render titleSlot?.()}
		{:else if href}
			<a {href}>
				{title}
			</a>
		{:else}
			{title}
		{/if}
	</h2>

	{#if iconAfter}
		<div class="text-primary-900 flex dark:text-white">
			{@render iconAfter?.()}
		</div>
	{/if}

	{@render children?.()}
</div>

{#if descriptionSlot || description}
	<div class="mt-2"></div>
{/if}

{#if description}
	<p>
		{description}
	</p>
{/if}

{@render descriptionSlot?.()}

{#if !noMargin}
	<div class="mt-7"></div>
{/if}
